export const TRANSLATIONS_JP_PLANS_AND_ADMIN = {
  "usage.period.month": "今月",
  "usage.hero.title": "今期の主要な使用量",
  "usage.hero.used": "使用",
  "usage.hero.no_data": "まだデータがありません",
  "admin.title": "管理",
  "admin.members": "メンバー",
  "admin.invite": "招待",
  "admin.pending": "保留中の招待",
  "admin.roles": "ロール",
  "admin.settings.title": "管理",
  "admin.settings.organizationName": "組織名",
  "admin.settings.inviteExpiryDays": "招待の有効期限（日数）（1～60）",
  "admin.settings.allowedDomains": "許可ドメイン（カンマまたは改行区切り）",
  "admin.settings.defaultRole": "既定のロール",
  "admin.settings.locale": "ロケール",
  "admin.members.title": "組織のメンバー",
  "admin.invite.title": "ユーザーを招待",
  "admin.invite.send": "招待を送信",
  "admin.invite.invitations": "招待",
  "admin.invite.resend": "招待を再送",
  "admin.invite.revoke": "招待を取り消す",
  "admin.invite.empty": "表示する招待はありません。",
  "admin.roles.title": "ロールと権限",
  "admin.roles.permissions": "権限",
  "admin.roles.delete": "ロールを削除",
};
